import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import DOMPurify from "isomorphic-dompurify";
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const sanitizeHTML = (content: string) => {
  return {
    __html: DOMPurify.sanitize(content, {
      ADD_ATTR: ['target'],
      ADD_TAGS: ['iframe']
    })
  };
};

export const shimmer = (w: number, h: number) => `
  <svg width="${w}" height="${h}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <linearGradient id="g">
        <stop stop-color="#333" offset="20%" />
        <stop stop-color="#222" offset="50%" />
        <stop stop-color="#333" offset="70%" />
      </linearGradient>
    </defs>
    <rect width="${w}" height="${h}" fill="#333" />
    <rect id="r" width="${w}" height="${h}" fill="url(#g)" />
  </svg>`

export const toBase64 = (str: string) =>
  typeof window === 'undefined'
    ? Buffer.from(str).toString('base64')
    : window.btoa(str)

/**
 * @param title - title for conversion to ID
 * @returns string ID, suitable for use in HTML attribute id
 * 
 * @example
 * generateAnchorId("Video Diaries") // "video-diaries"
 * generateAnchorId("About Dr. DeSilva") // "about-dr-desilva"
 * generateAnchorId("What is Deep Plane Facelift?") // "what-is-deep-plane-facelift"
 * generateAnchorId("Patient Testimonials & Reviews") // "patient-testimonials-reviews"
 */
export function generateAnchorId(title: string): string {
  if (!title) return '';
  
  return title
    .toLowerCase()
    .trim()
    // Replace spaces with hyphens
    .replace(/\s+/g, '-')
    // Remove special characters, keep only letters, numbers and hyphens
    .replace(/[^a-z0-9-]/g, '')
    // Remove multiple hyphens
    .replace(/-+/g, '-')
    // Remove hyphens at the beginning and end
    .replace(/^-+|-+$/g, '');
}
